<script setup lang="ts">
import { useI18n, RecordGrid } from '@thehotelsnetwork/widgets-core';

const props = withDefaults(
  defineProps<{
    data: {
      name: string;
      totalReviews: string;
      value: {
        score: string;
        max: number;
      };
    }[];
    direction?: 'ltr' | 'rtl';
  }>(),
  {
    direction: 'ltr',
  },
);
const { t } = useI18n();
</script>
<template>
  <div class="providersInfo font-base">
    <p class="mb-2 font-semibold">
      {{ t('Reviews by Source') }}
    </p>
    <RecordGrid
      :items="props.data"
      direction="column"
      :responsive="false"
      class="leading-5"
    >
      <template #name="{ item }">
        <div class="flex gap-1 items-baseline">
          <span class="font-semibold">{{ item.name }}</span>
          <span
            v-if="item.totalReviews"
            class="text-grey-500 text-xs"
          >
            {{ t('{num} reviews', { num: item.totalReviews}) }}
          </span>
        </div>
      </template>
      <template #value="{ item }">
        <strong class="text-base">{{ item.value.score }}</strong>
        <span class="text-grey-500">/{{ item.value.max }}</span>
      </template>
    </RecordGrid>
  </div>
</template>

<style scoped>
.providersInfo {
  direction: v-bind(props.direction);
}
</style>
